type SwitchProps = {
  checked: boolean;
  onChange: () => void;
};

export const Switch = ({ checked, onChange }: SwitchProps) => (
  <label className="inline-flex items-center cursor-pointer">
    <span className="sr-only">{checked ? 'Switch on' : 'Switch off'}</span>
    <input
      checked={checked}
      className="sr-only peer"
      type="checkbox"
      onChange={onChange}
    />
    <div className="relative w-[43px] h-[24px] bg-[#33455F] peer-focus:outline-none dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:start-[6px] rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[4px] after:start-[4px] after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-[#007AFE] dark:peer-checked:bg-[#fff] peer-checked:after:bg-[#007AFE] after:bg-[#FFFFFF80] shadow-none" />
  </label>
);
